export default __webpack_public_path__ + "static/media/nature 1.aff95430.jpg";